'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogActionsRegionStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  alignLeft: _propTypes2.default.bool,

  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};
var defaultProps = {
  alignLeft: false
};
/** Prop Receivers */

var align = function align(_ref) {
  var alignLeft = _ref.alignLeft;
  return alignLeft ? '\n    text-align: left;\n    justify-content: flex-start;\n  ' : '\n    text-align: right;\n    justify-content: flex-end;\n  ';
};

var childrenSpacing = function childrenSpacing(_ref2) {
  var themeFromProvider = _ref2.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.dialog.actionItem,
      marginX = _theme$reactackle$com.marginX,
      marginY = _theme$reactackle$com.marginY;
  return '\n    & > * {\n      margin: ' + (0, _reactackleCore.getValueString)(marginY) + ' ' + (0, _reactackleCore.getValueString)(marginX) + ';\n    }\n  ';
};
/** Styles */


var DialogActionsRegionStyled = exports.DialogActionsRegionStyled = _styledComponents2.default.div.withConfig({
  displayName: 'DialogActionsRegionStyled'
})(['flex-grow:1;display:flex;margin:0 !important;', ' ', ';'], align, childrenSpacing);

DialogActionsRegionStyled.propTypes = propTypes;
DialogActionsRegionStyled.defaultProps = defaultProps;
DialogActionsRegionStyled.displayName = 'DialogActionsRegionStyled';